import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const AdminAccountForm = () => {
  const { token, user } = useAuth();
  const [formData, setFormData] = useState({
    new_username: '',
    new_password: '',
    confirm_password: '',
    current_password: ''
  });
  const [saving, setSaving] = useState(false);

  const API = process.env.REACT_APP_BACKEND_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.current_password) {
      alert('Current password is required');
      return;
    }
    
    if (!formData.new_username && !formData.new_password) {
      alert('Please provide either a new username or new password');
      return;
    }
    
    if (formData.new_password && formData.new_password !== formData.confirm_password) {
      alert('New passwords do not match');
      return;
    }
    
    if (formData.new_password && formData.new_password.length < 8) {
      alert('New password must be at least 8 characters');
      return;
    }
    
    setSaving(true);
    
    try {
      const updateData = {
        current_password: formData.current_password
      };
      
      if (formData.new_username) {
        updateData.new_username = formData.new_username;
      }
      
      if (formData.new_password) {
        updateData.new_password = formData.new_password;
      }
      
      const response = await axios.post(`${API}/api/admin/account/update`, updateData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      alert('✅ Admin account updated successfully! Please login again with your new credentials.');
      
      // Clear form
      setFormData({
        new_username: '',
        new_password: '',
        confirm_password: '',
        current_password: ''
      });
      
      // Suggest logout
      if (formData.new_username || formData.new_password) {
        if (window.confirm('Your credentials have changed. Would you like to logout now?')) {
          window.location.href = '/login';
        }
      }
      
    } catch (error) {
      console.error('Error updating admin account:', error);
      alert('❌ Error: ' + (error.response?.data?.detail || error.message));
    } finally {
      setSaving(false);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="max-w-md mx-auto">
      <div className="mb-6 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
        <h4 className="font-semibold text-yellow-800 mb-2">⚠️ Security Notice</h4>
        <p className="text-yellow-700 text-sm">
          Changing your admin credentials will require you to login again. 
          Make sure to remember your new credentials!
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Current Username
          </label>
          <input
            type="text"
            value={user?.username || ''}
            disabled
            className="w-full p-3 border border-gray-200 rounded-lg bg-gray-50 text-gray-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            New Username (optional)
          </label>
          <input
            type="text"
            name="new_username"
            value={formData.new_username}
            onChange={handleInputChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
            placeholder="Leave blank to keep current username"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            New Password (optional)
          </label>
          <input
            type="password"
            name="new_password"
            value={formData.new_password}
            onChange={handleInputChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
            placeholder="Leave blank to keep current password"
            minLength={8}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Confirm New Password
          </label>
          <input
            type="password"
            name="confirm_password"
            value={formData.confirm_password}
            onChange={handleInputChange}
            className="w-full p-3 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
            placeholder="Confirm your new password"
            disabled={!formData.new_password}
          />
        </div>

        <div className="border-t border-gray-200 pt-4">
          <label className="block text-sm font-medium text-red-700 mb-1">
            Current Password (required) *
          </label>
          <input
            type="password"
            name="current_password"
            value={formData.current_password}
            onChange={handleInputChange}
            required
            className="w-full p-3 border border-red-300 rounded-lg focus:ring-red-500 focus:border-red-500"
            placeholder="Enter your current password to confirm changes"
          />
        </div>

        <button
          type="submit"
          disabled={saving || !formData.current_password}
          className="w-full bg-red-600 text-white px-6 py-3 rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50 font-medium"
        >
          {saving ? 'Updating Account...' : 'Update Admin Account'}
        </button>
      </form>
    </div>
  );
};

export default AdminAccountForm;